import createAsyncAction from "../../utils/asyncAction";
import * as api from "../api/nfc_card/nfc_card_api";
import * as types from "../constants/nfc_card_constants";

const getUserNfcCardsTypes = {
  success: types.GET_USER_NFC_CARDS_SUCCESS,
  failure: types.GET_USER_NFC_CARDS_FAILURE,
};

const applyNfcCardTypes = {
  success: types.APPLY_NFC_CARD_SUCCESS,
  failure: types.APPLY_NFC_CARD_FAILURE,
};

export const getUserNfcCards = createAsyncAction(
  api.getUserNfcCards,
  getUserNfcCardsTypes
);

export const applyNfcCard = createAsyncAction(
  api.applyNfcCard,
  applyNfcCardTypes
);

export const uploadNfcCardPhoto = (id, formData) => async (dispatch) => {
  try {
    const response = await api.uploadNfcCardPhoto(id, formData);
    const { error, data } = response;

    if (error) {
      dispatch({ type: types.UPLOAD_NFC_CARD_PHOTO_FAILURE, payload: error });
      return { error, data: null };
    }

    dispatch({ type: types.UPLOAD_NFC_CARD_PHOTO_SUCCESS, payload: data });
    return { error: null, data };
  } catch (error) {
    dispatch({
      type: types.UPLOAD_NFC_CARD_PHOTO_FAILURE,
      payload: "No Connection",
    });
    return { error: "No Connection", data: null };
  }
};
